module.exports = __webpack_public_path__ + "static/media/layout1.3bce2edf.png";